export default class ListMostRecentAttachmentRecordsByParentIdError extends Error {

}
